document.addEventListener("DOMContentLoaded", function () {
    let mediaTexts = document.querySelectorAll(".media-text");
    let mediaBlocks = document.querySelectorAll(".media-block");

    // Store original event listeners to avoid memory leaks
    const eventListeners = new WeakMap();

    function activateItem(id) {
        mediaTexts.forEach(t => t.classList.remove("active"));
        mediaBlocks.forEach(b => b.classList.remove("active"));

        const text = document.querySelector(`.media-text[data-id="${id}"]`);
        const block = document.querySelector(`.media-block[data-id="${id}"]`);

        if (text) text.classList.add("active");
        if (block) block.classList.add("active");
    }

    function initClickBehavior() {
        mediaTexts.forEach(text => {
            // Remove previous listeners if they exist
            if (eventListeners.has(text)) {
                const { clickListener, linkListener } = eventListeners.get(text);
                text.removeEventListener("click", clickListener);
                if (linkListener) {
                    const link = text.querySelector(".bnr-meta-link-wrap");
                    if (link) link.removeEventListener("click", linkListener);
                }
                eventListeners.delete(text);
            }

            const clickListener = function () {
                const id = this.getAttribute("data-id");
                const isActive = this.classList.contains("active");

                if (isActive) {
                    const url = this.querySelector(".bnr-meta-link-wrap")?.getAttribute("href");
                    if (url) window.location.href = url;
                } else {
                    activateItem(id);
                }
            };

            const link = text.querySelector(".bnr-meta-link-wrap");
            let linkListener = null;

            if (link) {
                linkListener = function (e) {
                    e.stopPropagation();
                };
                link.addEventListener("click", linkListener);
            }

            text.addEventListener("click", clickListener);
            eventListeners.set(text, { clickListener, linkListener });
        });
    }

    function initHoverBehavior() {
        mediaTexts.forEach(text => {
            // Remove previous listeners if they exist
            if (eventListeners.has(text)) {
                const { enterListener, leaveListener } = eventListeners.get(text);
                text.removeEventListener("mouseenter", enterListener);
                text.removeEventListener("mouseleave", leaveListener);
                eventListeners.delete(text);
            }

            const enterListener = function () {
                const id = this.getAttribute("data-id");
                activateItem(id);
            };

            const leaveListener = function () {
                const firstId = mediaTexts[0].getAttribute("data-id");
                activateItem(firstId);
            };

            text.addEventListener("mouseenter", enterListener);
            text.addEventListener("mouseleave", leaveListener);
            eventListeners.set(text, { enterListener, leaveListener });
        });
    }

    function setupBehavior() {
        if (window.innerWidth < 991) {
            initClickBehavior();
        } else {
            initHoverBehavior();
        }
    }

    function handleResize() {
        // Re-select elements in case they were replaced
        mediaTexts = document.querySelectorAll(".media-text");
        mediaBlocks = document.querySelectorAll(".media-block");
        setupBehavior();
    }

    // Initial setup
    setupBehavior();

    // Debounced resize handler
    let resizeTimeout;
    window.addEventListener("resize", function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 100);
    });

    // Activate first item by default
    if (mediaTexts.length > 0) {
        const firstId = mediaTexts[0].getAttribute("data-id");
        activateItem(firstId);
    }
});